<template>
	<div style="background: #f3f4f7">
		<dialogBox :dialogFlag="subFlag" @callFn="tcFn" @qrsFn="tcFn" title="您将离开组卷放弃当前试卷">
			<div class="tcBox">
				<div class="tcItem tcItem1">
					<div>
						<img src="@/assets/img/tm.svg" alt="" />
					</div>
					<p>共有：{{ temTestquest.examinationQuestionIdList?.length }}题</p>
				</div>
				<div class="tcItem tcItem2">
					<div>
						<img src="@/assets/img/yz.svg" alt="" />
					</div>
					<p>填充：{{ yzTnum }}题</p>
				</div>
				<div class="tcItem tcItem3">
					<div>
						<img src="@/assets/img/编组.svg" alt="" />
					</div>
					<p>空白：{{ wzTnum }}题</p>
				</div>
			</div>
			<template v-slot:footer>
				<div slot="footer">
					<div class="dialog-footer">
						<div class="loadBtn" @click="lkFn">确认离开</div>
						<div class="loadBtn loadBtnQr" @click="tcFn">继续组卷</div>
					</div>
				</div>
			</template>
		</dialogBox>
		<userHeader />
		<fuHeader :txt="a" type="2" height="53px" />
		<crumbs :txt="a" :crumFlag="true" bTxt="试题库" type="2" height="53px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="timsBox">
				<mobanXz ref="mobanXz" :disFlag="disFlag" @tabFn="tabFn" :mbData="mbData" />
				<timuXz :mxItem="mxItem" @disFn="disFn" @isZjFn="isZjFn" />
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import crumbs from '@/components/hearder/crumbs';
import fuHeader from '@/components/hearder/fuHeader';
import mobanXz from '@/components/tiku/mobanXz';
import timuXz from '@/components/tiku/timuXz';
import dialogBox from '@/components/pubComponents/dialogBox';
import { mapState } from 'vuex';

export default {
	name: 'xuanzMb',
	data() {
		return {
			type: 1, // 1文章 2视频 3音乐 4电影
			txt: '',
			mbData: [],
			disFlag: this.$route.query.tjStatus ? true : false,
			subFlag: false,
			tjStatus: '',
			yzTnum: 0,
			wzTnum: 0,
			isZjFlag: false,
			mxItem: {
				templateDetail: ''
			},
			a: ['试题库'],
			nextName: '',
			nextQuery: '',
			nextParams: ''
		};
	},

	components: {
		userHeader,
		fuHeader,
		foot,
		crumbs,
		mobanXz,
		timuXz,
		dialogBox
	},
	computed: {
		...mapState(['temTestquest'])
	},
	methods: {
		isZjFn(flag) {
			this.isZjFlag = flag;
		},
		lkFn() {
			this.subFlag = false;
			this.$router.push({
				path: this.nextName,
				query: {
					...this.nextQuery,
					tys: 777
				},
				params: {
					...this.nextParams
				}
			});
			console.log(this.nextName, '离开了');
		},
		tcFn() {
			this.subFlag = false;
		},
		lzFn() {
			this.decFlag = true;
		},
		tkFn() {
			this.decFlag = false;
		},
		disFn(flag) {
			this.disFlag = flag;
		},
		tabFn(item) {
			this.mxItem = item;
		},
		yusFn(type) {
			if (type == '-') {
				if (this.bsIns == 0) return;
				this.bsIns--;
			} else {
				if (this.bsIns == 5) return;
				this.bsIns++;
			}
		},
		pxFn(type) {
			this.pxFlag[type] == 2 ? (this.pxFlag[type] = 0) : this.pxFlag[type]++;
		},
		daBtn(s, index, b, val) {
			// item = val
			this.$set(this.daJh[s].children[index].tms, b, val);
		},
		btnFn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './scDec',
				query: {
					type: 1,
					txt: str
				}
			});
		},
		kaoBtn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './kaoshi',
				query: {
					txt: str
				}
			});
		},
		init() {
			this.$http.get('api/app/yydQuestionTypeTemplate/selectList').then((res) => {
				if (res.code == 200) {
					for (let item of res.data) {
						if (item.templateDetail) {
							item.templateDetail = JSON.parse(item.templateDetail).map((i, index) => {
								return {
									...i,
									uuid: index + 5,
									stdec: {}
								};
							});
						}
					}
					this.mbData = res.data || [];
					const { tjStatus } = this.$route.query;
					if (tjStatus) {
						let indexs = '';
						this.mbData.forEach((item, index) => {
							if (item.templateId == this.mxItem.templateId) {
								indexs = index;
							}
						});
						this.$nextTick(() => {
							this.$refs.mobanXz.tabFn(indexs, this.mxItem);
						});
					} else {
						this.mxItem = this.mbData[0];
						this.$nextTick(() => {
							this.$refs.mobanXz.tabFn(0, this.mbData[0]);
						});
					}
				}
			});
		}
	},
	activated() {
		const { tjStatus } = this.$route.query;
		if (tjStatus && this.temTestquest.examinationQuestionIdList) {
			this.mxItem = {
				templateId: this.temTestquest.templateId,
				templateDetail: this.temTestquest.examinationQuestionIdList.slice(5, this.temTestquest.examinationQuestionIdList?.length)
			};
			let num = 0;
			this.temTestquest.examinationQuestionIdList.forEach((item) => {
				if (item.stdec.examinationQuestionId) {
					num++;
				}
			});
			this.yzTnum = num;
			this.wzTnum = this.temTestquest.examinationQuestionIdList?.length - num;
			console.log(this.yzTnum, this.wzTnum, 44444);
		} else {
			this.init();
		}
	},
	beforeRouteLeave(to, from, next) {
		if (!this.isZjFlag) {
			next();
			return;
		}
		console.log(to, from, 222);
		if ((to.path == '/zujuan' && to.query.stStand) || to.path == '/mySj' || to.path == '/tihuanKt' || to.query.tys == '777') {
			next();
		} else {
			this.nextQuery = to.query;
			this.nextParams = to.params;
			this.nextName = to.path;
			this.subFlag = true;
		}
	},
	mounted() {
		const { type, txt } = this.$route.query;
		this.type = type || 1;
		this.txt = txt || '';
		this.a.push(txt);
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.timsBox {
	width: 1200px;
	margin: 0 auto 10px;
}
.tcBox {
	margin: 6px 0 40px;
	display: flex;
	justify-content: space-between;
	.tcItem {
		width: 133px;
		height: 93px;
		background: #f8f9fd;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		div {
			width: 34px;
			height: 34px;
			margin-bottom: 7px;
			display: flex;
			align-items: center;
			justify-content: center;
			img {
				width: 100%;
				height: 100%;
			}
		}
	}
	.tcItem1 {
		div {
			img {
				width: 30px;
				height: 30px;
			}
		}
		color: #000000;
	}
	.tcItem2 {
		color: #10c257;
	}
	.tcItem3 {
		color: #ff3030;
		div {
			img {
				width: 30px;
				height: 30px;
			}
		}
	}
}
.dialog-footer {
	display: flex;
	justify-content: center;
	padding-bottom: 10px;

	.loadBtn {
		width: 88px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: #d33931;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		font-size: 16px;
		color: #ffffff;
		border-radius: 6px;
		cursor: pointer;
	}
	.loadBtnQr {
		background: #1d7b3a;
		color: #ffffff;
		margin-left: 50px;
	}
}
</style>
